// src/components/KDSScreen/KDSScreen.jsx
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { apiFetch } from "../../utils/api";
import KDSCore from "./index"; // since you moved it into KDSScreen folder

export default function KDSScreen({ fixedRole }) {
  const { stationId } = useParams();
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function loadMeta() {
      try {
        setLoading(true);
        const res = await apiFetch(
          `/updates-reports/stations/by-station-id/${stationId}`
        );
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        if (!cancelled) {
          setMeta(data);
          setErr(null);
        }
      } catch (e) {
        console.error("❌ Failed to load station meta", e);
        if (!cancelled) setErr(e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    loadMeta();
    return () => {
      cancelled = true;
    };
  }, [stationId]);

  if (loading) return <div>Loading station…</div>;
  if (err || !meta) return <div>Failed to load station.</div>;

  const role = fixedRole || meta.role || "expo";

  return (
    <KDSCore
      stationId={Number(meta.station_id)}
      role={role}
      stationName={meta.station_name}
      stationTimezone={meta.timezone || "UTC"}
    />
  );
}
